import { makeAutoObservable } from 'mobx';
import { makePersistable } from 'mobx-persist-store';

import {
  SOLUTION_TYPE,
  SolutionType,
  SolutionTypeFlags,
} from '../constants/user-info/solutionType';
import { resetAllStore } from './resetAllStore';
import { broadcastEvent } from '../utils/angularUtils';
import { getFlagsObject } from '../utils/sortingAndGroupingUtil/getFlagsObject/getFlagsObject';
import { ANGULAR_EVENT_KEYS } from '../constants/system/ANGULAR_EVENT_KEYS';

type SolutionsInfo = {
  solutions: SolutionType[];
  solutionTypeFlags: SolutionTypeFlags;
};

class SolutionsStore {
  activeSolution: SolutionType | null = null;
  activeSolutionFlags: SolutionTypeFlags = {};
  availableSolutions: SolutionType[] = [];
  solutionTypeFlags: SolutionTypeFlags = {};

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
    makePersistable(this, {
      name: 'SolutionsStore',
      properties: ['solutionTypeFlags', 'availableSolutions'],
      storage: window.localStorage,
    });
  }

  setDefaultValues() {
    this.activeSolution = null;
    this.activeSolutionFlags = {};
    this.availableSolutions = [];
    this.solutionTypeFlags = {};
  }

  setSolutionsInfo({ solutions, solutionTypeFlags }: SolutionsInfo) {
    this.setAvailableSolutions(solutions);
    this.setSolutionTypeFlags(solutionTypeFlags);
  }

  private setActiveSolutionData(solution: SolutionType | null) {
    this.setActiveSolution(solution);
    this.setActiveSolutionFlags(solution);
    // Broadcast Angular event for same-tab reactivity
    broadcastEvent(ANGULAR_EVENT_KEYS.ACTIVE_SOLUTION_CHANGED);
  }

  setActiveSolutionFromRoute(solution: SolutionType | null) {
    this.setActiveSolutionData(solution);
  }

  private setActiveSolution(solution: SolutionType | null) {
    this.activeSolution = solution;
  }

  private setActiveSolutionFlags(activeSolution: SolutionType | null) {
    this.activeSolutionFlags = activeSolution
      ? getFlagsObject(SOLUTION_TYPE, [activeSolution])
      : {};
  }

  private setSolutionTypeFlags(solutionTypeFlags: SolutionTypeFlags) {
    this.solutionTypeFlags = solutionTypeFlags;
  }

  private setAvailableSolutions(availableSolutions: SolutionType[]) {
    this.availableSolutions = availableSolutions;
  }
}

const solutionsStore = new SolutionsStore();

resetAllStore.addResetMethod(solutionsStore.setDefaultValues);

export { solutionsStore, SolutionsStore };
